import { useApolloClient } from "@apollo/client";
import {
  Chip,
  Grid,
  Paper,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import { GetMasterSkill } from "../../../GQL/queries";
import { orderBy, uniqWith } from "lodash";
import Select from "@mostrans/web-components/components/base/Select";
import Checkbox from "@mostrans/web-components/components/base/Checkbox";

function FilterCandidate(props) {
  const { setCandidateOrder, setSkillValue, candidateSkills, setGenderValue } = props;
  const {
    setValueFilterExperienceMin,
    setValueFilterExperienceMax,
    setExcludedFilterExperience,
    setSelectedExperience,
    selectedExperience,
  } = props;
  // const [labelActive, setLabelActive] = useState("");
  const [masterSkills, setMasterSkills] = useState([]);
  const [genderMSelected, setGenderMSelected] = useState(false);
  const [genderFSelected, setGenderFSelected] = useState(false);
  const [isActiveEducation, setIsActiveEducation] = useState(false);
  const [isActiveGender, setIsActiveGender] = useState(false);
  const [isActiveExperience, setIsActiveExperience] = useState(false);
  const { filterValueEducation, setFilterValueEducation } = props;
  const client = useApolloClient();

  const useStyle = makeStyles({
    content: {
      justifyContent: "space-between",
      marginBottom: "-30px",
      marginTop: "5px",
    },
    root: {
      root: {
        borderRadius: "10px",
      },
      "&:before": {
        display: "none",
      },
      boxShadow: "none",
      borderRadius: "10px",
      "& .MuiAccordionSummary-root": {
        padding: "0 20px",
        boxShadow: "none",
        border: "none",
      },
      border: "none",
    },
    "& .MuiFormControlLabel-root": {
      width: "100%",
    },
  });

  const classes = useStyle();

  useEffect(() => {
    const fetchMasterSkills = async () => {
      GetMasterSkill(client).then((skill) => setMasterSkills(skill));
    };
    fetchMasterSkills();
  }, []);

  const listPendidikan = ["SMA/SMK", "D1", "D2", "D3", "S1", "S2", "S3"];

  const candidateSkillArr = candidateSkills.filter(Array.isArray).flat()
  const skillsArr = masterSkills.map(s => s.skill)
  const filterCandidateSkills = candidateSkillArr.filter(s => skillsArr.includes(s))
  const filterSkills = uniqWith(
    filterCandidateSkills,
    (val, other) =>
      val.toLowerCase().trim() === other.toLowerCase().trim()
  );
  const mappedSkills = filterSkills.map(function (skill) {
    return {
      value: skill,
      label: skill,
    };
  });
  const optionSkills = orderBy(mappedSkills, (o) => o.label.trim(), "asc");

  const optionOrder = [
    {
      value: "desc",
      label: "Newest to Oldest",
    },
    {
      value: "asc",
      label: "Oldest to Newest",
    },
  ];

  // const optionsEducation = listPendidikan.map(function (degree) {
  //   return {
  //     value: degree,
  //     label: degree,
  //   };
  // });

  const handleValueMale = () => {
    if (genderMSelected === false) {
      setGenderValue({ male: "M", female: "" });
      setGenderMSelected(true);
      setGenderFSelected(false);
    } else {
      setGenderValue({ male: "", female: "" });
      setGenderMSelected(false);
      setGenderFSelected(false);
    }
  };

  const handleValueFemale = () => {
    if (genderFSelected === false) {
      setGenderValue({ male: "", female: "F" });
      setGenderFSelected(true);
      setGenderMSelected(false);
    } else {
      setGenderValue({ male: "", female: "" });
      setGenderFSelected(false);
      setGenderMSelected(false);
    }
  };

  const onSelectFilterSKills = (e) => {
    if (!e) {
      e = {
        value: "",
      };
    }
    setSkillValue(e);
  };

  const handleCheckFilterEducation = (e) => {
    let updatedCheck = [...filterValueEducation];
    if (e.target.checked) {
      updatedCheck = [...filterValueEducation, e.target.value];
    } else {
      updatedCheck.splice(filterValueEducation.indexOf(e.target.value), 1);
    }
    setFilterValueEducation(updatedCheck);
  };

  const handleSelectedExperince = (e) => {
    let updatedCheck = [...selectedExperience];
    if (e.target.checked) {
      updatedCheck = [...selectedExperience, e.target.value];
    } else {
      updatedCheck.splice(selectedExperience.indexOf(e.target.value), 1);
    }
    setExcludedFilterExperience([]);
    if (
      updatedCheck.includes("selected3") &&
      updatedCheck.includes("selected2") &&
      updatedCheck.includes("selected1")
    ) {
      setValueFilterExperienceMin(0);
      setValueFilterExperienceMax(99);
    } else if (
      updatedCheck.includes("selected3") &&
      updatedCheck.includes("selected2")
    ) {
      setValueFilterExperienceMin(1);
      setValueFilterExperienceMax(99);
    } else if (
      updatedCheck.includes("selected3") &&
      updatedCheck.includes("selected1")
    ) {
      setValueFilterExperienceMin(0);
      setExcludedFilterExperience([1, 2, 3]);
      setValueFilterExperienceMax(99);
    } else if (
      updatedCheck.includes("selected2") &&
      updatedCheck.includes("selected1")
    ) {
      setValueFilterExperienceMin(0);
      setValueFilterExperienceMax(3);
    } else if (updatedCheck.includes("selected3")) {
      setValueFilterExperienceMin(4);
      setValueFilterExperienceMax(99);
    } else if (updatedCheck.includes("selected2")) {
      setValueFilterExperienceMin(1);
      setValueFilterExperienceMax(3);
    } else if (updatedCheck.includes("selected1")) {
      setValueFilterExperienceMin(0);
      setValueFilterExperienceMax(0);
    } else {
      setValueFilterExperienceMin(null);
      setValueFilterExperienceMax(null);
    }
    setSelectedExperience(updatedCheck);
  };

  return (
    <React.Fragment>
      <Grid item xs={12} md={4} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="form-row">
            <div className="col-md-12">
              <Typography sx={{ fontWeight: 500 }}>Sort Candidates</Typography>
            </div>
          </div>
          <div className="form-row mt-1">
            <div className="col-md-12">
              <Select
                placeholder="Sort by"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    boxShadow: "none",
                    border: "none",
                  }),
                  menu: (provided, state) => ({
                    ...provided,
                    boxShadow: "none",
                  }),
                }}
                options={optionOrder}
                onChange={(e) => setCandidateOrder(e.value)}
              />
            </div>
          </div>
          <div className="form-row mt-1">
            <div className="col-md-12">
              <Typography sx={{ fontWeight: 500 }}>
                Filter Your Search
              </Typography>
            </div>
          </div>
          <div className="form-row mt-1">
            <div className="col-md-12">
              <Select
                placeholder="Filter By Skill"
                options={optionSkills}
                onChange={(e) => onSelectFilterSKills(e)}
                isClearable
                isMulti
              />
            </div>
          </div>

          {/* <div className="form-row mt-1">
            <div className="col-md-12">
              <Select
                placeholder="Filter By Education"
                options={optionsEducation}
                onChange={(e) => handleEducationValue(e)}
                isClearable
              />
            </div>
          </div> */}
          <Accordion
            className={classes.root}
            disableGutters={true}
            defaultExpanded={true}
          >
            <AccordionSummary
              classes={{ content: classes.content }}
              onClick={() => setIsActiveEducation(!isActiveEducation)}
            >
              <Typography sx={{ fontWeight: 500 }}>Education</Typography>
              <div>
                {isActiveEducation !== true ? (
                  <span className="material-icons" style={{ marginBottom: 12 }}>
                    expand_less
                  </span>
                ) : (
                  <span className="material-icons" style={{ marginBottom: 12 }}>
                    expand_more
                  </span>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {listPendidikan.map((education, index) => (
                <FormControlLabel
                  key={index}
                  className="w-100"
                  control={
                    <Checkbox
                      onChange={(e) => handleCheckFilterEducation(e)}
                      value={education}
                      // sx={{ marginRight: "10px" }}
                    />
                  }
                  sx={{ textTransform: "capitalize" }}
                  label={education}
                />
              ))}
            </AccordionDetails>
          </Accordion>

          <Accordion
            className={classes.root}
            disableGutters={true}
            defaultExpanded={true}
          >
            <AccordionSummary
              classes={{ content: classes.content }}
              onClick={() => setIsActiveGender(!isActiveGender)}
            >
              <Typography sx={{ fontWeight: 500 }}>Gender</Typography>
              <div>
                {isActiveGender !== true ? (
                  <span className="material-icons" style={{ marginBottom: 12 }}>
                    expand_less
                  </span>
                ) : (
                  <span className="material-icons" style={{ marginBottom: 12 }}>
                    expand_more
                  </span>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="form-row mt-1">
                <div className="col-md-6">
                  <Chip
                    label="Male"
                    variant="outlined"
                    color={genderMSelected === true ? "primary" : "default"}
                    clickable
                    onClick={handleValueMale}
                  />
                </div>
                <div className="col-md-6">
                  <Chip
                    label="Female"
                    variant="outlined"
                    color={genderFSelected === true ? "primary" : "default"}
                    onClick={handleValueFemale}
                  />
                </div>
                <div className="mt-1"></div>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            className={classes.root}
            disableGutters={true}
            defaultExpanded={true}
          >
            <AccordionSummary
              classes={{ content: classes.content }}
              onClick={() => setIsActiveExperience(!isActiveExperience)}
            >
              <Typography sx={{ fontWeight: 500 }}>Experience</Typography>
              <div>
                {isActiveExperience !== true ? (
                  <span className="material-icons" style={{ marginBottom: 12 }}>
                    expand_less
                  </span>
                ) : (
                  <span className="material-icons" style={{ marginBottom: 12 }}>
                    expand_more
                  </span>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <FormControlLabel
                className="w-100"
                control={
                  <Checkbox
                    sx={{ marginRight: "10px" }}
                    value="selected1"
                    onChange={(e) => handleSelectedExperince(e)}
                  />
                }
                sx={{ textTransform: "capitalize" }}
                label="Less Than 1 Year"
              />
              <FormControlLabel
                className="w-100"
                control={
                  <Checkbox
                    sx={{ marginRight: "10px" }}
                    value="selected2"
                    onChange={(e) => handleSelectedExperince(e)}
                  />
                }
                sx={{ textTransform: "capitalize" }}
                label="1 - 3 Years"
              />
              <FormControlLabel
                className="w-100"
                control={
                  <Checkbox
                    sx={{ marginRight: "10px" }}
                    value="selected3"
                    onChange={(e) => handleSelectedExperince(e)}
                  />
                }
                sx={{ textTransform: "capitalize" }}
                label="> 3 Years"
              />
            </AccordionDetails>
          </Accordion>
        </Paper>
      </Grid>
    </React.Fragment>
  );
}

export default FilterCandidate;
